<template>
  <div class="row">
    <div class="col-2 p-0 bg-cx2">
      <status-menu :statuses="statuses" @select-status="onSelectStatus"></status-menu>
    </div>
    <div class="col-4 p-0 bg-white border-right orders-list">
      <orders-list :orders="orders" :selected-status="selectedStatus" @select-order="onSelectOrder">
      </orders-list>
    </div>
    <div class="col-6 p-0 bg-light order-detail">
      <div v-if="loading" class="loading text-muted">
        <h2><i class="fa fa-spinner spin"></i> Loading...</h2>
      </div>
      <order-detail v-else :order="order"></order-detail>
    </div>
  </div>
</template>

<script>
import api from '@/api.js'
import store from '@/stores/outbound.js'
import countBy from 'lodash/countBy'
import StatusMenu from '@/components/outbound/StatusMenu.vue'
import OrdersList from '@/components/outbound/OrdersList.vue'
import OrderDetail from '@/components/outbound/OrderDetail.vue'
import find from 'lodash/find'

export default {

  components: {
    StatusMenu,
    OrdersList,
    OrderDetail
  },
 
  data() {
    return {
      order: {},
      loading: false,
    }
  },

  watch: {
    '$route.params.id': function (id) {
      this.onSelectOrder(id)
    }
  },

  created: function() {
    api.get('/outbound-orders').then(res => {
      store.setOrders(res.data.orders)
    })

    api.get('/outbound-orders/statuses').then(res => {
      store.setStatuses(res.data.statuses)
    })
  },

  mounted() {
    if (this.$route.params.id) {
      this.onSelectOrder(this.$route.params.id)
    }
  },

  computed: {
    orders() {
      if (!this.selectedStatus.id || this.selectedStatus.id == 0) {
        return store.state.orders
      }
      return store.state.orders.filter((order) => {
        if(order.status_id == this.selectedStatus.id) {
          return true
        }
      })
    },

    selectedStatus() {
      return find(store.state.statuses, { slug: this.$route.params.status }) || {}
    },

    statuses() {
      const counts = countBy(store.state.orders, 'status_id')
      
      return store.state.statuses.map(status => {
        status.ct = counts[status.id]
        status.active = status.id == this.selectedStatus.id
        return status
      })
    },
  },

  methods: {
    onSelectOrder(id) {
      if (!id) {
        this.order = {}
      } else {
        this.loading = true
        api.get(`/outbound-orders/${id}`).then(res => {
          this.order = res.data.order
          this.loading = false
        })
      }      
    },

    onSelectStatus(status) {
      this.selectedStatus = status
      this.onSelectOrder({})
    }
  },
}

</script>

<style scoped>
.order-detail {
  height: calc(100vh - 48px);
  overflow-y: auto;
}
</style>